/**************************************************************************************************/
/*   File: /src/app/stores/reducers/index.ts                                                      */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed May 08 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import * as fromAuthorization from './authorization';
import * as fromDossiers from './dossiers';
import * as fromDownload from './download';
import * as fromCreation from './creation';
import * as fromDetails from './details';
import * as fromEditing from './editing';
import * as fromRoot from './root';
import * as fromUi from './ui';

export {
    fromAuthorization,
    fromDownload,
    fromCreation,
    fromDetails,
    fromEditing,
    fromUi,
    fromRoot,
    fromDossiers
};
